import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/api/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private auth:AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.auth.isLogged() && error.status === 401) {
          // Clear session tokens from local storage
          localStorage.removeItem("xAuthToken");
          localStorage.removeItem("access_token");

          // Redirect to the login page
          this.router.navigate(['/pages/error/session'], { queryParams: { returnUrl: this.router.url } });
        }
        if (error.status === 504) {
           // Clear session tokens from local storage
          localStorage.removeItem("xAuthToken");
          localStorage.removeItem("access_token");
          this.router.navigate(['/pages/error/timeout'], { queryParams: { returnUrl: this.router.url } });
        }
        return throwError(() => error);
      })
    );
  }
}
